import * as actionTypes from "./actionTypes";

const initialState = {
  isLoading: false,
  isLoadingModules: false,
  isLoadingActivities: false,
  courses: [],
  skillList: [],
  userFieldsDefinition: [],
  course: null,
  courseTree: null,
  modules: [],
  activities: [],
  media: [],
  activityTypes: [],
  questionTypes: [],
  sessionTypes: [],
  activity: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.RESET_ALL:
      return initialState;
    case actionTypes.GET_ALL_COURSES:
      return { ...state, isLoading: true };
    case actionTypes.GET_ALL_COURSES_FULFILLED:
      return {
        ...state,
        isLoading: false,
        courses: action.payload.courses,
        skillList: action.payload.skillList,
        userFieldsDefinition: action.payload.userFieldsDefinition,
      };
    case actionTypes.GET_ALL_COURSES_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_COURSE:
      return { ...state, isLoading: true };
    case actionTypes.GET_COURSE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        course: action.payload.course,
      };
    case actionTypes.GET_COURSE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.GET_COURSE_TREE:
      return { ...state, isLoading: true };
    case actionTypes.GET_COURSE_TREE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        courseTree: action.payload.courseTree,
      };
    case actionTypes.GET_COURSE_TREE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.CREATE_COURSE:
      return { ...state, isLoading: true };
    case actionTypes.CREATE_COURSE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        courses: action.payload.courses,
      };
    case actionTypes.CREATE_COURSE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.UPDATE_COURSE:
      return { ...state, isLoading: true };
    case actionTypes.UPDATE_COURSE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        courses: action.payload.courses,
      };
    case actionTypes.UPDATE_COURSE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DELETE_COURSE:
      return { ...state, isLoading: true };
    case actionTypes.DELETE_COURSE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        courses: action.payload.courses,
      };
    case actionTypes.DELETE_COURSE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.DUPLICATE_COURSE:
      return { ...state, isLoading: true };
    case actionTypes.DUPLICATE_COURSE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        courses: action.payload.courses,
      };
    case actionTypes.DUPLICATE_COURSE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.IMPORT_COURSE:
      return { ...state, isLoading: true };
    case actionTypes.IMPORT_COURSE_FULFILLED:
      return {
        ...state,
        isLoading: false,
        courses: action.payload.courses,
      };
    case actionTypes.IMPORT_COURSE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.EXPORT_COURSE:
      return { ...state, isLoading: true };
    case actionTypes.EXPORT_COURSE_FULFILLED:
      return { ...state, isLoading: false };
    case actionTypes.EXPORT_COURSE_REJECTED:
      return { ...state, isLoading: false };

    case actionTypes.RESET_COURSE:
      return {
        ...state,
        course: null,
      };

    // MODULES ///////////////////////////////////////////////////////////////////////////

    case actionTypes.GET_MODULES:
      return { ...state, isLoadingModules: true };
    case actionTypes.GET_MODULES_FULFILLED:
      return {
        ...state,
        isLoadingModules: false,
        modules: action.payload.modules,
      };
    case actionTypes.GET_MODULES_REJECTED:
      return { ...state, isLoadingModules: false };

    case actionTypes.CREATE_MODULE:
      return { ...state, isLoadingModules: true };
    case actionTypes.CREATE_MODULE_FULFILLED:
      return {
        ...state,
        isLoadingModules: false,
        modules: action.payload.modules,
      };
    case actionTypes.CREATE_MODULE_REJECTED:
      return { ...state, isLoadingModules: false };

    case actionTypes.UPDATE_MODULE:
      return { ...state, isLoadingModules: true };
    case actionTypes.UPDATE_MODULE_FULFILLED:
      return {
        ...state,
        isLoadingModules: false,
        modules: action.payload.modules,
      };
    case actionTypes.UPDATE_MODULE_REJECTED:
      return { ...state, isLoadingModules: false };

    case actionTypes.DELETE_MODULE:
      return { ...state, isLoadingModules: true };
    case actionTypes.DELETE_MODULE_FULFILLED:
      return {
        ...state,
        isLoadingModules: false,
        modules: action.payload.modules,
      };
    case actionTypes.DELETE_MODULE_REJECTED:
      return { ...state, isLoadingModules: false };

    // ACTIVITIES ///////////////////////////////////////////////////////////////////////////

    case actionTypes.GET_ACTIVITIES:
      return { ...state, isLoadingActivities: true };
    case actionTypes.GET_ACTIVITIES_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activities: action.payload.activities,
        media: action.payload.media,
        activityTypes: action.payload.activityTypes,
        questionTypes: action.payload.questionTypes,
        sessionTypes: action.payload.sessionTypes,
      };
    case actionTypes.GET_ACTIVITIES_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.GET_ACTIVITY:
      return { ...state, isLoadingActivities: true };
    case actionTypes.GET_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activity: action.payload.activity,
      };
    case actionTypes.GET_ACTIVITY_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.CREATE_ACTIVITY:
      return { ...state, isLoadingActivities: true };
    case actionTypes.CREATE_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activities: action.payload.activities,
        media: action.payload.media,
      };
    case actionTypes.CREATE_ACTIVITY_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.UPDATE_ACTIVITY:
      return { ...state, isLoadingActivities: true };
    case actionTypes.UPDATE_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activities: action.payload.activities,
        media: action.payload.media,
      };
    case actionTypes.UPDATE_ACTIVITY_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.DELETE_ACTIVITY:
      return { ...state, isLoadingActivities: true };
    case actionTypes.DELETE_ACTIVITY_FULFILLED:
      return {
        ...state,
        isLoadingActivities: false,
        activities: action.payload.activities,
        media: action.payload.media,
      };
    case actionTypes.DELETE_ACTIVITY_REJECTED:
      return { ...state, isLoadingActivities: false };

    case actionTypes.RESET_MODULES_AND_ACTIVITIES:
      return {
        ...state,
        modules: [],
        activities: [],
      };

    case actionTypes.RESET_ACTIVITY:
      return {
        ...state,
        activity: null,
      };

    default:
      return state;
  }
}
